export const nullToUndefined = <T>(value: T | null | undefined): T | undefined => {
	return value === null ? undefined : value;
};
